import React from 'react';

// const sections = [
//   {
//     label: 'S',
//     heading: 'ref-SUBJECTIVE',
//     children: [
//       { id: 'ref-SUBJECTIVE-CC', label: 'CC' },
//       { id: 'ref-SUBJECTIVE-N', label: 'N' },
//     ],
//   },
//   {
//     label: 'O',
//     heading: 'ref-OBJECTIVE',
//     children: [
//       { id: 'ref-OBJECTIVE-Vitals', label: 'V' },
//       { id: 'ref-OBJECTIVE-N', label: 'N' },
//     ],
//   },
//   {
//     label: 'A',
//     heading: 'ref-ASSESSMENT',
//     children: [
//       { id: 'ref-ASSESSMENT-P', label: 'P' },
//       { id: 'ref-ASSESSMENT-N', label: 'N' },
//     ],
//   },
//   {
//     label: 'P',
//     heading: 'ref-PLAN',
//     children: [
//       { id: 'ref-PLAN-N', label: 'N' },
//     ],
//   },
//   {
//     label: 'AI',
//     heading: 'ref-AdditionalINFO',
//     children: [
//       { id: 'ref-AdditionalINFO-DOC', label: 'DOC' },
//       { id: 'ref-AdditionalINFO-N', label: 'N' },
//     ],
//   },
// ];

//  = true
const SectionScrollNavigator = ({ encounterID, activeID, setActiveID, hoveredItem, setHoveredItem, ...props }) => {
  let { defaultSelectedItems } = props; 
  let { problems,
    observationNotes, problemArea, palpationNotes, rangeOfMotion, strength,  testMeasurementNotes, homeExerciseProgram, followUp, documents, additionalNotes } = defaultSelectedItems;
  const handleScrollIntoView = (id) => {
        setActiveID(id);
        setHoveredItem('');
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        //onNavigate?.(id); // Optional callback
    }
  };
  // console.log("defaultSelectedItemsSectionScrollNavigator", defaultSelectedItems)
  const insertPosition = props?.customTemplateData?.[0]?.InsertPosition || '';
  const sections = [ 
    ...(insertPosition === 'Top' ? 
      [{  id: `ref-CF${encounterID}`, label: 'CT' }] : []
    ),
    { id: `ref-SUBJECTIVE-CC${encounterID}`, label: 'CC' },
    ...(problems ? [{ id: `ref-ASSESSMENT-P${encounterID}`, label: 'P' }] : []),
    { id: `ref-SUBJECTIVE-N${encounterID}`, label: 'S' },
    {
      label: 'O',
      heading: `ref-OBJECTIVE${encounterID}`,
      children: [
        ...(observationNotes ? [{ id: `ref-OBJECTIVE-Obs${encounterID}`, label: 'Obs' }] : []),
        ...(problemArea ? [{ id: `ref-OBJECTIVE-PA${encounterID}`, label: 'PA' }] : []),
        ...(palpationNotes ? [{ id: `ref-OBJECTIVE-P${encounterID}`, label: 'P' }] : []),
        ...(rangeOfMotion ? [{ id: `ref-OBJECTIVE-R${encounterID}`, label: 'R' }] : []),
        ...(strength ? [{ id: `ref-OBJECTIVE-S${encounterID}`, label: 'S' }] : []),
        ...(testMeasurementNotes ? [{ id: `ref-OBJECTIVE-TANDM${encounterID}`, label: 'T&M' }] : []),
        { id: `ref-OBJECTIVE-N${encounterID}`, label: 'N' },
      ],
    },
    { id: `ref-ASSESSMENT-N${encounterID}`, label: 'A' },
    // {
    //   label: 'A',
    //   heading: `ref-ASSESSMENT${encounterID}`,
    //   children: [
    //     ...(assessmentAreaTreated ? [{ id: `ref-ASSESSMENT-AT${encounterID}`, label: 'AT' }] : []),
    //     ...(focusArea ? [{ id: `ref-ASSESSMENT-FA${encounterID}`, label: 'FA' }] : []),
    //     ...(assessmentMethodUsed ? [{ id: `ref-ASSESSMENT-MU${encounterID}`, label: 'MU' }] : []),
    //     { id: `ref-ASSESSMENT-N${encounterID}`, label: 'N' }
    //   ],
    // },
    {
      label: 'P',
      heading: `ref-PLAN${encounterID}`,
      children: [
        { id: `ref-PLAN-N${encounterID}`, label: 'N' },
        ...(homeExerciseProgram ? [{ id: `ref-PLAN-HEPN${encounterID}`, label: 'HEP' }] : []),
        ...(followUp ? [{ id: `ref-PLAN-FollowUp${encounterID}`, label: 'F' }] : []),
      ],
    },
    ...(insertPosition === 'Bottom' ? 
      [{  id: `ref-CF${encounterID}`, label: 'CT' }] : []
    ),
    ...(documents || additionalNotes) ?
    [{
      label: 'AI',
      heading: `ref-AdditionalINFO${encounterID}`,
      children: [
        ...(documents ? [{ id: `ref-AdditionalINFO-DOC${encounterID}`, label: 'DOC' }] : []),
        ...(additionalNotes ? [{ id: `ref-AdditionalINFO-N${encounterID}`, label: 'N' }] : []),
      ],
    }] : [],
  ];

  return (
    <>
      {sections.map((section, index) => (
        <>
        <div className="d-flex flex-column gap-5" key={index}>
        {section?.children?.length > 0 ?
          (<>
            <p
              id={`vertical-bar-${section.id}`}
              className={`heading text-center ${
              section.children
                ? [section.id, ...section.children.map(c => c.id)].includes(activeID)
                  ? 'orange-drk'
                  : ''
                : activeID === section.id  ? 'orange-drk' : ''
            }`}
              onClick={() => handleScrollIntoView(section.heading)}
            >
              {section.label}
            </p>
            {section?.children?.map((child) => (
              <p
                key={child.id}
                id={`vertical-bar-${child.id}`}
                className={`box font-m text ar-light-color ${
                  activeID === child.id ? 'active' : ''
                } ${
                  hoveredItem === child.id ? 'active' : ''
                }`}
                onClick={() => handleScrollIntoView(child.id)}
              >
                {child.label}
              </p>
            ))}
          </>): 
          (<p
            key={section.id}
            id={`vertical-bar-${section.id}`}
            className={`box font-m text ar-light-color ${
              activeID === section.id ? 'active' : ''
            } ${
              hoveredItem === section.id ? 'active' : ''
            }`}
            onClick={() => handleScrollIntoView(section.id)}
          >
            {section.label}
          </p>)
          }
          </div>
        </>
      ))}
    </>
  );
};

export default SectionScrollNavigator;
